// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Images
import bgImage from "assets/images/shapes/waves-white.svg";

// Styles for blinking animation
const blinkingStyle = {
  "@keyframes blink": {
    "0%": { opacity: 1 },
    "20%": { opacity: 0.2 },
    "40%": { opacity: 0.4 },
    "60%": { opacity: 0.6 },
    "80%": { opacity: 0.8 },
    "100%": { opacity: 1 },
  },
  animation: "blink 5s ease-in-out infinite",
};

function Download() {
  return (
    <MKBox component="section" py={{ xs: 0, sm: 12 }}>
      <MKBox
        variant="gradient"
        bgColor="dark"
        position="relative"
        borderRadius="xl"
        sx={{ overflow: "hidden" }}
      >
        <MKBox
          component="img"
          src={bgImage}
          alt="pattern-lines"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          zIndex={1}
          opacity={0.2}
        />
        <Container sx={{ position: "relative", zIndex: 2, py: 12 }}>
          <Grid container item xs={12} md={7} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography variant="h3" color="white">
              About me. Who am i?
            </MKTypography>
            <MKTypography variant="h3" color="warning" mb={1}>
              <center>
                <br></br>
                &amp; What i am doing?
              </center>
            </MKTypography>
            <MKTypography variant="body2" color="white" mb={4}>
              My ❤️ for programming languages is profound. My primary 🎯 is to innovate and
              introduce novel concepts to aspiring programmers. Your collective 🤖 support is
              indispensable for achieving this endeavor.
            </MKTypography>
            <MKButton
              variant="gradient"
              color="info"
              size="large"
              component="a"
              href="https://about.me/codeshowlapz"
              sx={{ mb: 2 }}
            >
              Find Here
            </MKButton>
          </Grid>
        </Container>
      </MKBox>
      <Container>
        <Grid container item xs={10} mx="auto">
          <MKBox textAlign="center" width="100%">
            <MKTypography variant="h3" mt={8} mb={7}>
              Available on These Playlists
            </MKTypography>
            <Grid container spacing={10} justifyContent="center" alignItems="center">
              <Grid item xs={6} sm={4} md={2} lg={1.4}>
                <Tooltip title="Java">
                  <MKBox
                    component="a"
                    href="https://www.youtube.com/playlist?list=PLNK2Mv-w5CH1uHMEDnY_IY8Bzbfx1Kdvc"
                    target="_blank"
                    sx={blinkingStyle}
                  >
                    <MKBox
                      component="img"
                      src="https://cdn.worldvectorlogo.com/logos/java-4.svg"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={6} sm={4} md={2} lg={1.5}>
                <Tooltip title="C#">
                  <MKBox
                    component="a"
                    href="https://www.youtube.com/playlist?list=PLNK2Mv-w5CH308hPvYyP4nQJLeNmVr5iL"
                    target="_blank"
                    sx={blinkingStyle}
                  >
                    <MKBox
                      component="img"
                      src="https://cdn.worldvectorlogo.com/logos/c--4.svg"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={6} sm={4} md={2} lg={1.5}>
                <Tooltip title="C++">
                  <MKBox
                    component="a"
                    href="https://www.youtube.com/playlist?list=PLNK2Mv-w5CH2yxDWixpaHMQQGEt1doCdu"
                    target="_blank"
                    sx={blinkingStyle}
                  >
                    <MKBox
                      component="img"
                      src="https://cdn.worldvectorlogo.com/logos/c.svg"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={6} sm={4} md={2} lg={1.6}>
                <Tooltip title="Python">
                  <MKBox
                    component="a"
                    href="https://www.youtube.com/playlist?list=PLNK2Mv-w5CH0-UiboBR59_0xNV76iapMz"
                    target="_blank"
                    sx={blinkingStyle}
                  >
                    <MKBox
                      component="img"
                      src="https://cdn.worldvectorlogo.com/logos/python-4.svg"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={6} sm={4} md={2} lg={1.5}>
                <Tooltip title="Dart">
                  <MKBox
                    component="a"
                    href="https://www.youtube.com/playlist?list=PLNK2Mv-w5CH3laf4XKyO0xViuDB6OG1RL"
                    target="_blank"
                    sx={blinkingStyle}
                  >
                    <MKBox
                      component="img"
                      src="https://cdn.worldvectorlogo.com/logos/dart.svg"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={6} sm={4} md={2} lg={3}>
                <Tooltip title="MERN">
                  <MKBox
                    component="a"
                    href="https://www.youtube.com/playlist?list=PLNK2Mv-w5CH1noBXJFLmWYsyzGtYpu6Ew"
                    target="_blank"
                    sx={blinkingStyle}
                  >
                    <MKBox
                      component="img"
                      src="https://miro.medium.com/v2/resize:fit:678/0*kxPYwfJmkXZ3iCWy.png"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
              <Grid item xs={6} sm={4} md={2} lg={1.5}>
                <Tooltip title="Swift">
                  <MKBox
                    component="a"
                    href="https://www.youtube.com/playlist?list=PLNK2Mv-w5CH05XZ6uJJ9XsfB-NVc-nY6d"
                    target="_blank"
                    sx={blinkingStyle}
                  >
                    <MKBox
                      component="img"
                      src="https://cdn.worldvectorlogo.com/logos/swift-15.svg"
                      width="100%"
                    />
                  </MKBox>
                </Tooltip>
              </Grid>
            </Grid>
          </MKBox>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Download;
